import { useArgusAtom } from './argus';
import { useEffect } from 'react';
import * as api from '../../../../../serverApi';
import { t } from '../../../../../lib/i18n';

interface Props {
  sensorCompositeId?: string;
}

export function AutomaticMarkingsToggle(props: Props) {
  const [atom, setAtom] = useArgusAtom();

  useEffect(() => {
    if (props.sensorCompositeId) {
      api
        .getArgusDisabledCategories(props.sensorCompositeId)
        .then((res) => {
          setAtom({
            ...atom,
            disabledCategories: {
              bed: res.categories.includes('bed'),
              chair: res.categories.includes('chair'),
              seating_group: res.categories.includes('seating_group'),
            },
          });
        })
        .catch((err) => {
          console.error('Failed to get disabled categories', err);
        });
    }
  }, [props.sensorCompositeId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        // border: '1px solid #ccc',
        // borderRadius: '4px',
        // backgroundColor: 'rgba(255,255,255,0.5)',
        // padding: '4px',
        display: 'flex',
        flexFlow: 'column nowrap',
        marginTop: '8px',
        marginBottom: '8px',
      }}
    >
      <label
        style={{
          // marginLeft: '6px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'baseline',
          marginBottom: '4px',
        }}
      >
        <input
          type="checkbox"
          style={{
            marginRight: '6px',
            height: '18px',
            width: '18px',
            transform: 'translateY(2px)',
          }}
          checked={atom.showSuggestions}
          onChange={(e) => {
            setAtom({
              ...atom,
              showSuggestions: e.target.checked,
            });
          }}
        />
        {t('components.AutomaticMarkingsToggle.showSuggestions')}
      </label>

      <div
        style={{
          fontSize: '14px',
          color: '#555',
        }}
      >
        {t('components.AutomaticMarkingsToggle.helpText')}
      </div>
    </div>
  );
}
